import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { UseHeader, Icon } from '@cps'
import languageMobx from '@mobx/app/language.mobx'
import { useHistoryNew } from '@utils'
import languageController from '@ctrls/languageController'
import mktController from '@ctrls/mktController'
import i18n from 'i18next'
import { localStore } from '@dt/fe-utils'
import './index.scss'

// interface
interface IProps extends IPage, RouteComponentProps {
}

const MyLanguage: FC<IProps> = () => {
  const [language, setLanguage] = useState<string>('')
  const history = useHistoryNew()
  // Component Eveent
  const handleClick = (val: any) => {
    languageController.changeLanguage(val)
  }
  // Component Effect
  useIonViewWillEnter(() => {
    setLanguage(localStore.get(`i18nextLng.${Config.BRANDID}`))
  })
  return (
    <IonPage className='language-page'>
      <UseHeader title={i18n.t('mkt.setting.languageSelect')} onBack={() => mktController.goBack(history)} />
      <IonContent className='page-content'>
        <div className='fix-block'></div>
        <div className='setting-list'>
          {
            languageMobx.languageList.map((item: any, index: number) => (
              <div
                data-cypid='mmgChangeLanguage'
                key={index} className='setting-item' onClick={() => {
                  if (language === item) return
                  handleClick(item)
                }}
              >
                <div className='item-block'>
                  <div className='name'>{languageController.languageLabel[item]}</div>
                  <div className='link'>
                    {language === item && <Icon name='check' />}
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(MyLanguage)
